const toCapitalizedCase = (text: string): string => {
	if (!text) return "";
	return text
		.toLowerCase()
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
};

export const parseAddress = (addressString: string) => {
	if (!addressString || typeof addressString !== "string") {
		return {
			addressLine1: "",
			addressLine2: "",
			pincode: "",
			stateName: "",
			cityName: "",
			countryName: "India",
		};
	}

	try {
		let pincode = "";

		const pinMatch = addressString.match(/PIN:\s*(\d{6})/i);
		if (pinMatch) {
			pincode = pinMatch[1];
		}

		const cleanedAddress = addressString
			.replace(/PIN:\s*\d{6}/i, "")
			.replace(/\s+,/g, ",")
			.trim();

		const parts = cleanedAddress.split(",").map((part) => part.trim());

		let addressLine1 = "";
		let addressLine2 = "";
		let cityName = "";
		let stateName = "";
		const countryName = "India";

		if (parts.length >= 1) {
			addressLine1 = toCapitalizedCase(parts[0]);
		}

		if (parts.length >= 2) {
			addressLine2 = toCapitalizedCase(parts[1]);
		}

		if (parts.length >= 3) {
			cityName = toCapitalizedCase(parts[2]);
		}

		if (parts.length >= 4) {
			stateName = toCapitalizedCase(parts[3]);
		}

		return {
			addressLine1,
			addressLine2,
			pincode,
			stateName,
			cityName,
			countryName,
		};
	} catch (error) {
		console.error("Error parsing address:", error);
		return {
			addressLine1: addressString,
			addressLine2: "",
			pincode: "",
			stateName: "",
			cityName: "",
			countryName: "India",
		};
	}
};
